var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * @desc ordinal scale
 */
import Scale from './scale';
import { niceTicks } from './helper';
import { log } from '../utils/math';
import * as lodash from '../utils/lodash';
import template from '../utils/template';
/**
 * linear scale
 */
var LogScale = /** @class */ (function (_super) {
    __extends(LogScale, _super);
    function LogScale(min, max, start, end, logBase) {
        if (logBase === void 0) { logBase = 10; }
        var _this = _super.call(this) || this;
        _this.type = 'log';
        _this.ticks = [];
        _this.logBase = 10;
        _this.min = min;
        _this.max = max;
        _this.start = start;
        _this.end = end;
        _this.ticks = [min, max];
        _this.logBase = logBase;
        _this.minLog = log(min, logBase);
        _this.maxLog = log(max, logBase);
        return _this;
    }
    LogScale.prototype.clone = function () {
        return new LogScale(this.min, this.max, this.start, this.end, this.logBase);
    };
    LogScale.prototype.scale = function (value) {
        if (this.min === this.max) {
            return (this.start + this.end) / 2;
        }
        return (this.start +
            ((this.end - this.start) * (log(lodash.toNumber(value), this.logBase) - this.minLog)) /
                (this.maxLog - this.minLog));
    };
    LogScale.prototype.invert = function (position) {
        return (Math.pow(this.logBase, (this.minLog +
            (this.maxLog - this.minLog) * (position - this.start) * (this.start - this.end))));
    };
    LogScale.prototype.niceTicks = function (tickCount, conf) {
        var _this = this;
        if (conf === void 0) { conf = {}; }
        var ticks = niceTicks(Math.floor(this.minLog), Math.ceil(this.maxLog), tickCount, {
            minInterval: 1,
            interval: conf.interval ? log(conf.interval, this.logBase) : conf.interval,
            maxInterval: null,
        });
        this.minLog = ticks[0];
        this.maxLog = ticks[ticks.length - 1];
        this.min = Math.pow(this.logBase, this.minLog);
        this.max = Math.pow(this.logBase, this.maxLog);
        this.ticks = ticks.map(function (tick) { return Math.pow(_this.logBase, tick); });
    };
    LogScale.prototype.getTicks = function () {
        return this.ticks;
    };
    LogScale.prototype.getLabel = function (value) {
        var index = this.getTicks().indexOf(value);
        var isFirst = index === 0;
        var isLast = index === this.getTicks().length - 1;
        if (lodash.isString(this.formatter)) {
            return template(this.formatter, { value: value, index: index, isFirst: isFirst, isLast: isLast });
        }
        if (lodash.isFunction(this.formatter)) {
            return this.formatter(value, index, { isFirst: isFirst, isLast: isLast });
        }
        return value.toString();
    };
    LogScale.prototype.getValueDomain = function () {
        return [this.max, this.min];
    };
    LogScale.prototype.getPositionRange = function () {
        return [this.end, this.start];
    };
    return LogScale;
}(Scale));
export default LogScale;
